import { api } from '../utils/request'

export const flightBooking = async (data) => {
    const resp = await api({
        endpoint: '/flightBooking',
        method: 'POST',
        data,
    })
    return resp
}